'use client'

import React from "react";

type SplashProps = {
    className?: string;
    text?: string | null | boolean;
    isOpen?: boolean;
};

const Splash: React.FC<SplashProps> = ({ className, text, isOpen = true }) => {
    return (
        <div className={`fixed inset-0 bg-white bg-opacity-[0.8] z-[95] ${className || ""} ${isOpen ? '' : 'hidden'}`}>
            <div className={"fixed inset-0 flex items-center justify-center select-none cursor-wait"}>

                <span className={" bg-opacity-[0.2] rounded-full p-[15px] flex flex-col justify-center items-center gap-md"}>
                    <img
                        src={"/assets/images/NeatolabsSplash.svg"}
                        alt="Loading..."
                        className={" w-[70px] h-[70px] opacity-[0.3]"}
                    />
                    {typeof text === "string" && <span className={"text-text-md text-gray-400 text-opacity-70"}>{text}</span>}
                </span>
            </div>
        </div>
    );
};

export default Splash;

